import { render, staticRenderFns } from "./SecondaryNavigationMenuItem.vue?vue&type=template&id=23f5df14&scoped=true"
import script from "./SecondaryNavigationMenuItem.vue?vue&type=script&lang=js"
export * from "./SecondaryNavigationMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SecondaryNavigationMenuItem.vue?vue&type=style&index=0&id=23f5df14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5df14",
  null
  
)

export default component.exports